import { useMutation, useQuery } from "@apollo/client/react";
import { Spin } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from "react-router";
import { OfflineBlocker } from "../components/OfflineBlocker.tsx";
import { GetCurrentLoggedUserDocument, LogoutDocument } from "../gql/generated/graphqlSchema.tsx";
import { AppLayout } from "../layout/AppLayout.tsx";
import { routes } from "../routes.ts";

export const AuthenticatedRoutes = () => {
  const { data, loading, refetch } = useQuery(GetCurrentLoggedUserDocument);
  const [logout] = useMutation(LogoutDocument);
  const { i18n } = useTranslation();

  const currentUser = data?.getCurrentLoggedUser ?? null;
  const persistedLocale = currentUser?.locale ?? null;

  useEffect(() => {
    if (persistedLocale && i18n.language !== persistedLocale) {
      void i18n.changeLanguage(persistedLocale);
    }
  }, [persistedLocale, i18n]);

  if (loading) {
    return <Spin fullscreen size="large" />;
  }

  const handleLogout = async () => {
    await logout();
    await refetch();
  };

  if (!currentUser) {
    return <Navigate replace to={routes.login.to()} />;
  }

  return (
    <>
      <OfflineBlocker />
      <AppLayout
        currentUser={currentUser}
        onLogout={() => {
          void handleLogout();
        }}
        refetchUser={refetch}
      >
        <Outlet />
      </AppLayout>
    </>
  );
};
